import classNames from 'classnames';
import Image from 'next/image';
import styles from './doctor-facts.module.scss';

export interface DoctorFactsCardProps {
    image: {
        src: string;
        width: number;
        height: number;
    };
    name: string;
    title: string;
    title2?: string;
    description: string;
}

const DoctorFactsCard = (props: DoctorFactsCardProps) => {
    return (
        <article className={classNames(styles['card'])}>
            <Image
                src={props.image.src}
                width={props.image.width}
                height={props.image.height}
                alt={props.name}
                className={classNames(styles['card--thumbnail'])}
            />
            <p className={classNames(styles['card--name'])}>{props.name}</p>
            <p className={classNames(styles['card--title'])}>{props.title}</p>
            {props.title2 && (
                <p className={classNames(styles['card--title'])}>
                    {props.title2}
                </p>
            )}
            <p className={classNames(styles['card--description'])}>
                {props.description}
            </p>
        </article>
    );
};

export default DoctorFactsCard;
